import { FC } from 'react';

import { useCountriesQuery } from 'Dictionary/query/dictionaryQuery';
import {
  FormikAutocompleteField,
  FormikAutocompleteFieldProps,
} from 'components/FormikField/FormikAutocompleteField/FormikAutocompleteField';
import { useMyProfileQuery } from 'MyProfile/query/myProfile.query';
import { Country } from 'Dictionary/model/Country';

export interface CountriesSelectFieldProps
  extends Omit<FormikAutocompleteFieldProps, 'options' | 'label'> {
  label?: string
}

export const CountriesSelectField: FC<CountriesSelectFieldProps> = (props) => {
  const { data = [], isLoading, refetch } = useCountriesQuery();
  const { data: userData } = useMyProfileQuery();
  const isAdmin = userData?.isAdmin;
  const allowedcountry = userData?.roles?.flatMap(role =>
    role.details?.map(detail => detail?.description2?.split('-')?.[0]?.trim())
  ).filter(Boolean) ?? [];
  const filteredcountryData = (data ?? []).filter((d) => allowedcountry?.includes(d.name));
  let selectedOption: Country[]
  if (!isAdmin && !allowedcountry?.includes("ALL COUNTRIES")) {
    selectedOption = filteredcountryData
  }
  else {
    selectedOption = data
  }

  return (
    <FormikAutocompleteField
      options={selectedOption}
      label={props.label ?? "Country/Territory"}
      loading={isLoading}
      onOpen={() => refetch()}
      multiple
      {...props}
    />
  );
};
